import RestResource from "@/api/rest/rest-resource";
import {athubAxios} from "@/util";
import {ORGANIZATION_SERVER} from "@/api";

const employeePosition = new RestResource({server: ORGANIZATION_SERVER, resource: 'employeePosition'});

employeePosition.bind = (employeePositions) => {
    let url = `${ORGANIZATION_SERVER}/employeePosition/bind`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, employeePositions).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

employeePosition.unbind = (employeePositionId) => {
    let url = `${ORGANIZATION_SERVER}/employeePosition/unbind/${employeePositionId}`;
    return new Promise((resolve, reject) => {
        athubAxios.get(url).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

employeePosition.findDetailByPage = (pageSearch) => {
    return athubAxios.post(`${ORGANIZATION_SERVER}/employeePosition/detail/page`, pageSearch);
};

export default employeePosition;